import { Compass, Telescope } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

export const MissionVision = () => (
  <section data-testid="mission-vision-section" className="py-24 sm:py-32">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal className="mb-12">
        <Overline>Mission &amp; Vision</Overline>
      </Reveal>
      <div className="grid gap-5 lg:grid-cols-2">
        <Reveal>
          <div data-testid="mission-card" className="group h-full rounded-[2rem] bg-night p-8 text-cream transition-transform duration-500 hover:-translate-y-1.5 sm:p-10">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-peach/15 text-peach">
              <Compass size={22} strokeWidth={1.8} />
            </span>
            <h3 className="mt-6 font-display text-3xl uppercase tracking-wider text-peach">Our Mission</h3>
            <p className="mt-4 text-base leading-relaxed text-cream/80 sm:text-lg">
              is to help youth envision the future they truly want, and to guide them through complete
              transformation to reach it — powered by their own potential, and grounded in a clear, honest
              understanding of their own capabilities.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div data-testid="vision-card" className="group h-full rounded-[2rem] border border-peach/25 bg-gradient-to-br from-cream-dark to-white p-8 transition-transform duration-500 hover:-translate-y-1.5 sm:p-10">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-peach-dark/10 text-peach-dark">
              <Telescope size={22} strokeWidth={1.8} />
            </span>
            <h3 className="mt-6 font-display text-3xl uppercase tracking-wider text-peach-dark">My Vision</h3>
            <p className="mt-4 text-base leading-relaxed text-ink-muted sm:text-lg">
              A world where potential doesn't go to waste — where every person, regardless of where they start, has
              access to the tools, awareness, and support needed to become who they're truly capable of being, and
              where that growth ripples outward into stronger families, communities, and nations.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
